import { ModelEntitySearchResponseItem } from '@upright/common/model/search/types';
import { useIsMappableProduct } from '@upright/ui/api/model/input/products/mappable-products';
import { SingleValueProps } from 'react-select';
import styled from 'styled-components';

export function getCustomSingleValue(
  showProductCode: boolean | undefined,
  highlightNonMappableProduct: boolean | undefined,
) {
  const titleColor = highlightNonMappableProduct ? 'red' : undefined;
  const SingleValue = <IsMulti extends boolean>(props: SingleValueProps<ModelEntitySearchResponseItem, IsMulti>) => {
    const isMappable = useIsMappableProduct();

    const productCode = props.data.id;
    const productTitle = props.data.name;

    return (
      <SingleValueRoot>
        <ValueName color={!isMappable(productCode) ? titleColor : undefined}>{productTitle}</ValueName>
        {showProductCode && <ProductCode>{productCode}</ProductCode>}
      </SingleValueRoot>
    );
  };
  return SingleValue;
}

export const CustomSingleValue = getCustomSingleValue(false, false); // Default

const SingleValueRoot = styled.div``;
const ValueName = styled.div<{ color?: string }>`
  color: ${props => props.color};
`;
const ProductCode = styled.span`
  color: deeppink;
`;
